import type { SeoMeta } from "@/interfaces/seo";

type SeoPageOverride = Pick<SeoMeta, "title" | "description">;

const SEO_PAGE_OVERRIDES: Record<string, SeoPageOverride> = {
  "/courses/": {
    title: "All Training Courses: Aesthetics, Beauty, Laser and SPMU",
    description:
      "Every Cosmetic College course in one place: VTCT Level 2 to 7, CPD, laser, skin, permanent makeup and hair. Practical days in Orpington, theory online.",
  },
  "/courses/aesthetics/": {
    title: "Aesthetics Courses UK | VTCT and CPD | Cosmetic College",
    description:
      "VTCT regulated qualifications and CPD-accredited aesthetics courses for beginners and professionals, taught in small groups with live models supplied.",
  },
  "/courses/beauty/": {
    title: "Beauty Courses London and Kent | Cosmetic College",
    description:
      "CPD-accredited beauty courses in London and Kent, from lashes and brows to skin and body treatments. Small groups with live models supplied for practice.",
  },
  "/courses/laser/": {
    title: "Laser Training Courses London | VTCT Level 4 and 5",
    description:
      "Laser courses in Orpington, near London: VTCT Level 4 Laser and IPL, Level 5 laser tattoo removal, online Core of Knowledge and RPL.",
  },
  "/courses/skin/": {
    title: "Skin Courses London | VTCT Level 4 and 5 Skin Training",
    description:
      "VTCT skin training in Orpington, near London: Level 4 microneedling, peels, dermaplaning and HIFU, then Level 5 skin. Small classes, models supplied.",
  },
  "/courses/medical-professionals/": {
    title: "Level 7 Aesthetics for Medical Professionals | VTCT Skills",
    description:
      "VTCT Skills (ITEC) Level 7 injectable routes for doctors, dentists, nurses and regulated healthcare professionals: MA7D1, MA7D2 RPEL and MA7C1.",
  },
  "/courses/elearning/": {
    title: "Online Aesthetic Courses UK | CPD and VTCT Theory Training",
    description:
      "Online aesthetic, beauty and injectables theory courses. Start today, study at your own pace and earn a CPD or VTCT theory certificate.",
  },
  "/courses/fast-track-training/": {
    title: "Fast Track Hairdressing, Beauty and Aesthetics Courses",
    description:
      "Fast track VTCT hairdressing, beauty and aesthetics courses for career changers and professionals, with practical days in Orpington, near London.",
  },
  "/courses/elearning/microneedling/": {
    title: "Microneedling Online Course | CPD Theory Training",
    description:
      "Online microneedling course: consultation, client suitability, contraindications, aftercare and treatment planning. Study at your own pace. CPD.",
  },
  "/courses/elearning/dermaplaning/": {
    title: "Dermaplaning Online Course | CPD Theory Training",
    description:
      "Online dermaplaning course: consultation, client suitability, contraindications, aftercare and treatment planning. Study at your own pace. CPD.",
  },
  "/courses/elearning/high-definition-brows-training/": {
    title: "HD Brows Online Course | High Definition Brows CPD",
    description:
      "Online HD brows course covering consultation, client suitability, contraindications, aftercare and treatment planning. Study at your own pace. CPD.",
  },
  "/courses/elearning/face-and-body-waxing/": {
    title: "Waxing Course Online | Face and Body Waxing CPD",
    description:
      "Online face and body waxing course: consultation, client suitability, contraindications, aftercare and treatment planning. Study at your own pace.",
  },
  "/courses/hair/": {
    title: "Hairdressing Courses London | Fast Track VTCT and Extensions",
    description:
      "Hairdressing training in Orpington, near London: VTCT Level 2 Fast Track Women's Hairdressing and hair extension masterclasses, practised on live models.",
  },
  "/courses/elearning/online-phlebotomy-training-course/": {
    title: "Phlebotomy Online Course | CPD Theory Training",
    description:
      "Online phlebotomy course: consultation, risk awareness, contraindications, aftercare and practical progression. Study at your own pace. CPD.",
  },
  "/courses/elearning/lash-lift-and-tint/": {
    title: "Lash Lift Online Course | Lash Lift and Tint CPD",
    description:
      "Online lash lift and tint course: consultation, client suitability, contraindications, aftercare and treatment planning. Study at your own pace.",
  },
  "/courses/vtct/": {
    title: "VTCT Courses London | Level 3 to Level 7 | Cosmetic College",
    description:
      "VTCT courses in Orpington, near London: Level 3 access, Level 4 laser and skin, Level 5 skin and tattoo removal, Level 7 injectables. Theory online.",
  },
  "/courses/semi-permanent-makeup/": {
    title: "Semi Permanent Makeup Courses London | VTCT and CPD",
    description:
      "Permanent makeup and microblading training in Orpington, near London: VTCT Level 4 microblading and micropigmentation, plus CPD brows, lips and liner.",
  },
  "/contact/": {
    title: "Contact Cosmetic College | Orpington BR6 | 0333 015 5117",
    description:
      "Call 0333 015 5117 or message admissions about courses, dates and finance. Visit us at 3 Locks Court, 429 Crofton Rd, Orpington BR6 8NL.",
  },
  "/reviews/": {
    title: "Cosmetic College Reviews: What Our Students Say",
    description:
      "Read Google reviews from Cosmetic College learners on VTCT and CPD aesthetics, laser, skin and beauty courses at our Orpington training centre.",
  },
  "/courses/vtct/level-2-facial-and-skincare-course/": {
    title: "Facial Courses London | VTCT Level 2 Qualification",
    description:
      "Regulated VTCT Level 2 facial and skincare qualification in Orpington, near London, to start a facialist career. No experience needed. Theory online.",
  },
  "/courses/vtct/level-7-certificate-in-non-surgical-aesthetic-injectable-procedures/":
    {
      title: "Level 7 Injectables Certificate | VTCT | Medic and Non-medic",
      description:
        "VTCT Level 7 Certificate in injectables for medics and non-medics who meet entry rules, a smaller award than the diploma. Orpington.",
    },
  "/courses/elearning/vtct-itec-level-4-award-in-principles-and-practice-of-aesthetic-therapies/":
    {
      title: "VTCT Level 4 Aesthetics Online Theory | Principles Award",
      description:
        "Study the VTCT iTEC Level 4 Award in Principles and Practice of Aesthetic Therapies online, at your own pace, with the theory exams taken remotely.",
    },
  "/courses/elearning/facial-and-skin-online-training-bundle/": {
    title: "Online Dermaplaning, Peels and Microneedling Theory | CPD",
    description:
      "Online theory bundle covering dermaplaning, chemical peels, microneedling and LED: consultation, contraindications and aftercare. CPD certificate.",
  },
  "/courses/elearning/vtct-itec-level-4-award-in-core-of-knowledge-for-laser-and-light-devices/":
    {
      title: "VTCT Level 4 Core of Knowledge for Laser | Online Theory",
      description:
        "Study the VTCT iTEC Level 4 Award in Core of Knowledge for Laser and Light Devices online, with remote theory exams. A separate course from Level 4 laser.",
    },
  "/blog/how-to-become-a-professional-facialist/": {
    title: "How to Become a Facialist in the UK: Courses and Steps",
    description:
      "What a facialist does, the qualifications you need from VTCT Level 2 upwards, how training is assessed and how to start working in the UK.",
  },
  "/blog/how-to-become-a-permanent-makeup-artist/": {
    title: "How to Become a Permanent Makeup Artist in the UK (2026)",
    description:
      "Regulated VTCT Level 4 routes into microblading and micropigmentation, entry rules, timings, and how to register with your council in Kent or London.",
  },
  "/blog/step-by-step-guide-on-how-to-become-a-beauty-therapist/": {
    title: "How to Become a Beauty Therapist in the UK | 2026 Guide",
    description:
      "Start with the VTCT Level 3 Access course, no experience needed, then add Level 3 and Level 4 skills. Routes, entry requirements, pay and licensing.",
  },
  "/blog/laser-hair-removal-courses-for-beginners/": {
    title: "Laser Hair Removal Courses for Beginners: Where to Start",
    description:
      "New to laser? Start with a Level 3, then VTCT Level 4 Laser and IPL (3 practical days, 20 online theory hours), then Level 5 tattoo removal.",
  },
  "/courses/vtct/level-7-diploma-in-non-surgical-aesthetic-injectable-procedures/": {
    title: "Level 7 Aesthetics Diploma | VTCT | Medics and Non-medics",
    description:
      "VTCT Level 7 Diploma in injectables for medics and non-medics who meet entry rules. Orpington, near London. 0% plans over 3, 6 or 9 months.",
  },
  "/courses/vtct/level-4-certificate-in-advanced-aesthetic-therapies-for-skin/": {
    title: "Level 4 Aesthetics Course London | Microneedling & Peels",
    description:
      "VTCT Level 4 aesthetics near London (Orpington): microneedling and chemical peels in one certificate. 2 webinar days, 5 training days, models supplied.",
  },
  "/courses/vtct/level-4-in-skin-microneedling/": {
    title: "Microneedling Course London | VTCT Level 4 Qualification",
    description:
      "Regulated VTCT Level 4 microneedling qualification near London (Orpington) for Level 3 therapists and medics. Up to 6 a class, models supplied.",
  },
  "/courses/vtct/laser-hair-removal/": {
    title: "Laser Hair Removal Course London | VTCT Level 4",
    description:
      "Laser hair removal training near London: VTCT Level 4 Laser and IPL. 3 practical days, 20 hours online theory, class of 6, models supplied.",
  },
  "/courses/vtct/level-3-award-in-body-massage/": {
    title: "Level 3 Body Massage Course London | VTCT Award",
    description:
      "VTCT Level 3 Award in Body Massage in Orpington, near London. Theory online, then practical days on models we supply, with your VTCT assessments.",
  },
  "/courses/vtct/level-3-award-in-indian-head-massage/": {
    title: "Indian Head Massage Course London | VTCT Level 3",
    description:
      "VTCT Level 3 Award in Indian Head Massage in Orpington, near London. Theory online, then practical days on models we supply, with your VTCT assessments.",
  },
  "/courses/vtct/level-3-award-in-massage-using-pre-blended-aromatherapy-oils/": {
    title: "Aromatherapy Massage Course London | VTCT Level 3",
    description:
      "VTCT Level 3 Award in Massage using Pre-Blended Aromatherapy Oils in Orpington, near London. Theory online, then practical days on models we supply.",
  },
  "/pathway-to-aesthetics/": {
    title: "Pathway to Aesthetics Course London | VTCT Level 3 to 7",
    description:
      "Pathway to Aesthetics course for medics and non-medics: VTCT Level 3 to Level 7 in Orpington, near London. Book each step or the package. Plans available.",
  },
  "/courses/vtct/level-3-certificate-in-access-to-aesthetic-therapies/": {
    title: "Level 3 Access to Aesthetics Course London | VTCT",
    description:
      "No experience needed. VTCT Level 3 Access to Aesthetics course near London (Orpington), the entry route to Level 4. 3 practical days, models supplied.",
  },
  "/courses/vtct/level-4-certificate-in-micropigmentation/": {
    title: "Permanent Makeup Course London | VTCT L4 Micropigmentation",
    description:
      "Regulated VTCT Level 4 permanent makeup course near London: brows, lips and eyeliner. 6 practical days, max 6 per class, models and kit included.",
  },
  "/courses/vtct/level-4-award-in-high-intensity-focused-ultrasound-hifu/": {
    title: "HIFU Training Course London | VTCT Level 4 Qualification",
    description:
      "Regulated VTCT Level 4 HIFU qualification near London (Orpington) for Level 3 therapists and healthcare professionals. Up to 6 per class, models supplied.",
  },
  "/courses/vtct/level-4-certificate-in-enhancing-eyebrows-with-microblading-techniques/":
    {
      title: "Microblading Course London | VTCT Level 4 Certificate",
      description:
        "VTCT Level 4 microblading training near London (Orpington). A regulated brow certificate, open to beginners, with live models we supply on training days.",
    },
  "/courses/vtct/level-4-award-in-skin-peeling/": {
    title: "Chemical Peel Course London | VTCT Level 4 Qualification",
    description:
      "Regulated VTCT Level 4 chemical peel qualification near London (Orpington) for Level 3 therapists and medics. Superficial peels on live models, up to 6.",
  },
  "/courses/vtct/level-4-radio-frequency-and-ultrasound/": {
    title: "Radio Frequency and Ultrasound Course | VTCT Level 4",
    description:
      "Two regulated VTCT Level 4 qualifications, radio frequency and ultrasound, near London (Orpington) for Level 3 therapists and medics. Classes of 6.",
  },
  "/courses/vtct/level-4-award-in-dermaplaning/": {
    title: "Dermaplaning Course London | VTCT Level 4 Qualification",
    description:
      "Regulated VTCT Level 4 dermaplaning qualification near London (Orpington) for Level 3 therapists and medics. Blade technique on live models, up to 6.",
  },
  "/courses/vtct/vtct-level-4-plasma-pen-training/": {
    title: "Plasma Pen Course London | VTCT Level 4 Qualification",
    description:
      "Regulated VTCT Level 4 plasma pen qualification near London (Orpington) for Level 3 therapists and medics. Pen included, subject to stock. Live models.",
  },
  "/courses/vtct/level-5-certificate-in-non-surgical-aesthetic-procedures-for-skin/": {
    title: "Level 5 Aesthetics Course London | VTCT Skin Rejuvenation",
    description:
      "VTCT Level 5 aesthetics course near London (Orpington): advanced peels, needling, mesotherapy and LED. Max 6 per class, models supplied.",
  },
  "/courses/vtct/level-5-certificate-in-laser-tattoo-removal/": {
    title: "Laser Tattoo Removal Training Course | VTCT Level 5",
    description:
      "Train in laser tattoo removal with the VTCT Level 5 course in Orpington, near London. For Level 4 laser therapists. Class of 6, models supplied.",
  },
  "/courses/packages/vtct-itec-aesthetics-fast-track-package/": {
    title: "VTCT Level 3 & 4 Aesthetics Fast-Track London",
    description:
      "Enroll in our combined Level 3 & 4 VTCT/ITEC training. Master advanced facial therapies, laser treatments, and more to elevate your aesthetics career.",
  },
  "/course-prices/": {
    title: "Course Prices UK | VTCT, CPD & E-learning | Cosmetic College",
    description:
      "Compare Cosmetic College course prices including VAT for VTCT qualifications, CPD practical courses and e-learning, with payment plan options. Orpington.",
  },
  "/courses/vtct/vtct-level-3-award-in-education-and-training/": {
    title: "Level 3 Award in Education and Training London | VTCT",
    description:
      "VTCT Level 3 Award in Education and Training near London (Orpington): e-learning plus an onsite micro-teach, to teach beauty and aesthetics.",
  },
  "/courses/vtct/vtct-level-3-certificate-in-assessing-vocational-achievement/": {
    title: "CAVA Assessor Course London | VTCT Level 3 Certificate",
    description:
      "VTCT Level 3 Certificate in Assessing Vocational Achievement (CAVA) near London (Orpington). Learn to assess beauty and aesthetics learners.",
  },
  "/courses/vtct/level-3-award-in-basic-life-support-aed-and-management-of-anaphylaxis/": {
    title: "Level 3 BLS AED Anaphylaxis Course London | First Aid",
    description:
      "VTCT Level 3 first aid for aesthetics: adult CPR, AED and anaphylaxis near London (Orpington). Meets the Level 5 skin entry rule.",
  },
  "/courses/vtct/level-4-award-in-the-internal-quality-assurance-of-assessment-processes/": {
    title: "Level 4 IQA Course London | VTCT Internal Quality Assurance",
    description:
      "VTCT Level 4 Award in Internal Quality Assurance (IQA) near London (Orpington), for assessors who quality assure assessment in a centre.",
  },
  "/courses/vtct/level-5-award-in-radiofrequency-microneedling/": {
    title: "RF Microneedling Course London | VTCT Level 5 Qualification",
    description:
      "VTCT Level 5 RF microneedling course near London (Orpington) on the 3D Aesthetics Dermaforce, for Level 4 microneedling practitioners. Models supplied.",
  },
  "/courses/vtct/level-5-chemical-skin-peels/": {
    title: "Level 5 Chemical Peel Course | Advanced VTCT Qualification",
    description:
      "Advanced VTCT Level 5 chemical peel qualification near London (Orpington), the next step after a Level 4 peel award. Live models supplied, up to 6 a class.",
  },
  "/courses/vtct/level-6-award-in-mesotherapy-treatments/": {
    title: "Mesotherapy Course London | VTCT Level 6 Qualification",
    description:
      "Regulated VTCT Level 6 mesotherapy qualification near London (Orpington) for practitioners with Level 5 needling, or Level 4 needling and CPD mesotherapy.",
  },
  "/courses/aesthetics/foundation-anti-wrinkle-injections-course/": {
    title: "Anti-Wrinkle Injection Training London | CPD Course",
    description:
      "Foundation anti-wrinkle injection course near London (Orpington): e-learning, then a practical session on models we supply. Groups of 4 learners.",
  },
  "/courses/aesthetics/foundation-dermal-fillers/": {
    title: "Dermal Filler Training London | Foundation CPD Course",
    description:
      "Foundation dermal filler course near London (Orpington): e-learning, then 2 practical days on models we supply. Groups of 4 learners.",
  },
  "/courses/aesthetics/skin-boosters/": {
    title: "Skin Booster Training London | CPD Course",
    description:
      "Skin booster course near London (Orpington): e-learning, then a practical session on models we supply, using BAP and micro-puncture. Groups of 4.",
  },
  "/courses/aesthetics/polynucleotides-skin-rejuvenation/": {
    title: "Polynucleotide Training London | CPD Course",
    description:
      "Polynucleotides skin rejuvenation course near London (Orpington): e-learning, then a practical session on models we supply. Groups of 4 learners.",
  },
  "/courses/aesthetics/aqualyx-fat-dissolving/": {
    title: "Fat Dissolving Injection Training London | CPD",
    description:
      "Fat dissolving injection course near London (Orpington) for practising injectors: e-learning, then a practical session on models we supply. Groups of 4.",
  },

  "/courses/injectables/8-point-face-lift-training/": {
    title: "8 Point Face Lift Training London | CPD Masterclass",
    description:
      "8 point face lift dermal filler masterclass near London (Orpington) for practising injectors: e-learning, then a practical session on models. Groups of 4.",
  },
  "/courses/aesthetics/advanced-anti-wrinkle-injections-course/": {
    title: "Advanced Anti-Wrinkle Injection Training London | CPD",
    description:
      "Advanced anti-wrinkle injection course near London (Orpington) for practising injectors: e-learning, then a practical session on models. Groups of 4.",
  },
  "/courses/aesthetics/advanced-lip-enhancement-masterclass/": {
    title: "Advanced Lip Filler Masterclass London | CPD Course",
    description:
      "Advanced lip filler masterclass near London (Orpington): e-learning, then a practical day on models we supply. Russian lip and more. Groups of 4.",
  },
  "/courses/injectables/cannula-masterclass/": {
    title: "Cannula Masterclass London | CPD Training Course",
    description:
      "Cannula masterclass near London (Orpington) for practising injectors: e-learning, then a practical session on models we supply. Groups of 4 learners.",
  },
  "/courses/aesthetics/carbon-laser-facial-training/": {
    title: "Carbon Laser Facial Training London | CPD Course",
    description:
      "Carbon laser facial (Hollywood Peel) course near London (Orpington): e-learning, then a practical day on models we supply. Groups of 4 learners.",
  },
  "/courses/aesthetics/chemical-skin-peels/": {
    title: "Chemical Skin Peel Training | CPD Short Course",
    description:
      "Short CPD chemical skin peel course near London (Orpington): e-learning, then a practical session on models using Clinicare peels. Groups of 4.",
  },
  "/courses/aesthetics/hair-filler-training-course/": {
    title: "Hair Filler Training London | CPD Course",
    description:
      "Injectable hair filler course near London (Orpington): e-learning, then a practical day on models we supply. Groups of 4 learners.",
  },
  "/courses/aesthetics/jawline-dermal-fillers-masterclass/": {
    title: "Cheek, Jawline and Chin Filler Masterclass London | CPD",
    description:
      "Cheek, jawline and chin dermal filler masterclass near London (Orpington): e-learning, then a practical day on models. Needle and cannula. Groups of 4.",
  },
  "/courses/aesthetics/mesotherapy-training/": {
    title: "Mesotherapy Training for Beginners | CPD Short Course",
    description:
      "Short CPD mesotherapy course near London (Orpington) for medics, non-medics and beginners: e-learning, then a practical session on models. Groups of 4.",
  },
  "/courses/aesthetics/mesotoxin/": {
    title: "Mesotoxin Training Course | Cosmetic College",
    description:
      "Mesotoxin training near London (Orpington): a microinjection skin technique. E-learning, then a practical session on models we supply. Groups of 4.",
  },
  "/courses/aesthetics/non-surgical-rhinoplasty-masterclass/": {
    title: "Non-Surgical Rhinoplasty Masterclass London | CPD",
    description:
      "Non-surgical rhinoplasty dermal filler masterclass near London (Orpington) for practising injectors: e-learning, then a practical session. Groups of 4.",
  },
  "/courses/aesthetics/phlebotomy/": {
    title: "Phlebotomy Training London | CPD Course",
    description:
      "Phlebotomy course near London (Orpington) for beginners: e-learning, then a half-day practical session with models we supply. Groups of 4.",
  },
  "/courses/aesthetics/plasma-bio-filler/": {
    title: "Plasma Bio Gel Filler Training London | CPD Course",
    description:
      "Plasma bio gel filler course near London (Orpington) for practising injectors with PRP training: e-learning, then a practical day. Groups of 4.",
  },
  "/courses/aesthetics/plla-collagen-stimulators-sculptra-and-aesplla/": {
    title: "PLLA Training London | Sculptra and Aesplla CPD Course",
    description:
      "PLLA collagen stimulator course near London (Orpington) for practising injectors: e-learning, then a practical session on models we supply. Groups of 4.",
  },
  "/courses/aesthetics/prp-vampire-facial/": {
    title: "PRP Training London | Platelet Rich Plasma CPD Course",
    description:
      "Platelet rich plasma (PRP) course near London (Orpington) for practitioners: e-learning, then a practical day, face and hair PRP. Groups of 4.",
  },
  "/courses/aesthetics/tear-trough-masterclass/": {
    title: "Tear Trough Filler Masterclass London | CPD Course",
    description:
      "Tear trough dermal filler masterclass near London (Orpington) for practising injectors: e-learning, then a practical session. Groups of 4.",
  },
  "/courses/aesthetics/vitamin-b12-injections/": {
    title: "Vitamin B12 Injection Training London | CPD Course",
    description:
      "Vitamin B12 intramuscular injection course near London (Orpington): e-learning, then a practical session on models we supply. Groups of 4 learners.",
  },

  // Brief 05 Appendix A: shorten titles (non-Ads, non-Level-7, non-CONFIRM)
  "/blog/category/choosing-an-aesthetics-training-provider/": {
    title: "Choosing An Aesthetics Training Provider Guides",
    description:
      "Guides to help you choose an aesthetics training provider in the UK, including what to check before you enrol.",
  },
  "/blog/category/choosing-an-aesthetics-training-route/": {
    title: "Choosing An Aesthetics Training Route Guides",
    description:
      "Guides to aesthetics training routes in the UK, from entry pathways to regulated VTCT qualifications.",
  },
  "/careers/internal-verifier-quality-assurer/": {
    title: "Internal Verifier / Quality Assurer Job in Orpington",
    description:
      "Apply for the Internal Verifier and Quality Assurer role at Cosmetic College in Orpington, near London.",
  },
  "/cosmetic-college-app/": {
    title: "Cosmetic College App for iPhone, iPad and Android",
    description:
      "Download the Cosmetic College app for course updates, training support and student resources on iPhone, iPad and Android.",
  },
  "/courses/beauty-therapists/": {
    title: "Advanced Training for Qualified Beauty Therapists",
    description:
      "Advanced beauty and aesthetics training routes for qualified beauty therapists at Cosmetic College in Orpington, near London.",
  },
  "/courses/elearning/aesthetics/": {
    title: "Online Aesthetics Courses | Learn and Get Certified",
    description:
      "Browse online aesthetics training courses from Cosmetic College, with e-learning routes you can complete remotely.",
  },
  "/courses/rpl/": {
    title: "Recognition of Prior Learning for Aesthetics",
    description:
      "Recognition of Prior Learning (RPL) routes for VTCT aesthetics qualifications at Cosmetic College in Orpington, near London.",
  },
  "/courses/rpl/laser-hair-removal/": {
    title: "VTCT Level 4 Laser Hair Removal RPL Route",
    description:
      "Recognition of Prior Learning route for the VTCT Level 4 Certificate in Laser Hair Removal and IPL at Cosmetic College.",
  },
  "/courses/rpl/level-3-certificate-in-access-to-aesthetic-therapies/": {
    title: "VTCT Level 3 Access to Aesthetics RPL Route",
    description:
      "Recognition of Prior Learning route for the VTCT Level 3 Certificate in Access to Aesthetic Therapies.",
  },
  "/courses/rpl/level-4-award-in-high-intensity-focused-ultrasound-hifu/": {
    title: "VTCT Level 4 HIFU RPL Route",
    description:
      "Recognition of Prior Learning route for the VTCT Level 4 Award in High Intensity Focused Ultrasound (HIFU).",
  },
  "/courses/rpl/level-4-certificate-in-enhancing-eyebrows-with-microblading-techniques/":
    {
      title: "VTCT Level 4 Microblading RPL Route",
      description:
        "Recognition of Prior Learning route for the VTCT Level 4 Certificate in Enhancing Eyebrows with Microblading Techniques.",
    },
  "/courses/rpl/level-4-certificate-in-micropigmentation/": {
    title: "VTCT Level 4 Micropigmentation RPL Route",
    description:
      "Recognition of Prior Learning route for the VTCT Level 4 Certificate in Micropigmentation at Cosmetic College.",
  },
  "/courses/rpl/level-4-in-skin-microneedling/": {
    title: "VTCT Level 4 Skin Microneedling RPL Route",
    description:
      "Recognition of Prior Learning route for the VTCT Level 4 Award in Skin Microneedling at Cosmetic College.",
  },
  "/courses/rpl/level-4-radio-frequency-and-ultrasound/": {
    title: "VTCT Level 4 Radio Frequency RPL Route",
    description:
      "Recognition of Prior Learning route for the VTCT Level 4 Award in Radio Frequency and Ultrasound.",
  },
  "/courses/rpl/level-5-certificate-in-laser-tattoo-removal/": {
    title: "VTCT Level 5 Laser Tattoo Removal RPL Route",
    description:
      "Recognition of Prior Learning route for the VTCT Level 5 Certificate in Laser Tattoo Removal.",
  },
  "/courses/rpl/level-5-certificate-in-non-surgical-aesthetic-procedures-for-skin/":
    {
      title: "VTCT Level 5 Skin Rejuvenation RPL Route",
      description:
        "Recognition of Prior Learning route for the VTCT Level 5 Certificate in Non-surgical Aesthetic Procedures for Skin Rejuvenation.",
    },
  "/courses/rpl/level-6-award-in-mesotherapy-treatments/": {
    title: "VTCT Level 6 Mesotherapy RPL Route",
    description:
      "Recognition of Prior Learning route for the VTCT Level 6 Award in Mesotherapy Treatments at Cosmetic College.",
  },
  "/courses/rpl/vtct-level-4-plasma-pen-training/": {
    title: "VTCT Level 4 Plasma Pen RPL Route",
    description:
      "Recognition of Prior Learning route for the VTCT Level 4 Award in Plasma Pen Techniques at Cosmetic College.",
  },
  "/courses/semi-permanent-makeup/eyeliner-and-lash-enhancements/": {
    title: "Eyeliner and Lash Enhancement Masterclass Training",
    description:
      "Eyeliner and lash enhancement permanent makeup masterclass training at Cosmetic College in Orpington, near London.",
  },
  "/courses/vtct/vtct-level-2-certificate-in-womens-hairdressing/": {
    title: "VTCT Level 2 Certificate in Women's Hairdressing",
    description:
      "VTCT Level 2 Certificate in Women's Hairdressing in Orpington, near London, for learners starting a hairdressing career.",
  },
  "/courses/vtct/vtct-level-5-diploma-in-education-and-training/": {
    title: "VTCT Level 5 Diploma in Education and Training",
    description:
      "VTCT Level 5 Diploma in Education and Training in Orpington, near London, for tutors and trainers in beauty and aesthetics.",
  },
  "/franchise-with-us/": {
    title: "Beauty and Aesthetics Training Franchise Opportunity",
    description:
      "Explore a beauty and aesthetics training franchise opportunity with Cosmetic College and start your own training college.",
  },
  "/guides/": {
    title: "Guide Versions and Updates | Free Aesthetics eBooks",
    description:
      "Browse free aesthetics eBooks and guide updates from Cosmetic College, including compliance, pricing and client growth resources.",
  },
  "/models/treatments/discounted-anti-wrinkle-injections-london/": {
    title: "Discounted Anti-Wrinkle Model Appointments in London",
    description:
      "Book discounted anti-wrinkle model appointments in London at Cosmetic College training clinics.",
  },
  "/models/treatments/discounted-chemical-peels-london/": {
    title: "Discounted Chemical Peel Model Appointments in London",
    description:
      "Book discounted chemical peel model appointments in London at Cosmetic College training clinics.",
  },
  "/models/treatments/discounted-dermal-filler-london/": {
    title: "Discounted Lip and Dermal Filler Model Appointments",
    description:
      "Book discounted lip and dermal filler model appointments in London at Cosmetic College training clinics.",
  },
  "/models/treatments/discounted-microneedling-london/": {
    title: "Discounted Microneedling Model Appointments in London",
    description:
      "Book discounted microneedling model appointments in London at Cosmetic College training clinics.",
  },
  "/models/treatments/discounted-permanent-makeup-model-london/": {
    title: "Discounted Permanent Makeup Model Appointments London",
    description:
      "Book discounted permanent makeup model appointments in London at Cosmetic College training clinics.",
  },
  "/models/treatments/discounted-skin-boosters-polynucleotides-london/": {
    title: "Discounted Skin Booster Model Appointments London",
    description:
      "Book discounted skin booster and polynucleotide model appointments in London at Cosmetic College training clinics.",
  },
  "/resources/compliance-checklist/": {
    title: "Free eBook: UK Aesthetics Compliance Checklist",
    description:
      "Download the free UK aesthetics compliance checklist covering insurance, consent and clinic paperwork essentials.",
  },
  "/resources/perfect-before-and-after/": {
    title: "Free eBook: Before and After Photography Guide",
    description:
      "Download the free before and after photography guide for aesthetics, covering consent and marketing use.",
  },
  "/resources/price-with-confidence/": {
    title: "Free eBook: Price With Confidence for Aesthetics",
    description:
      "Download the free aesthetics treatment pricing guide and learn how to price with confidence.",
  },
  "/resources/treatment-room-to-business/": {
    title: "Free eBook: Treatment Room to Business Guide",
    description:
      "Download the free guide to building recurring revenue as a beauty or aesthetics therapist.",
  },
  "/resources/your-first-50-clients/": {
    title: "Free eBook: Your First 50 Clients in Aesthetics",
    description:
      "Download the free marketing guide for aesthetics therapists building their first 50 clients.",
  },
  "/start-a-career-in-permanent-makeup/": {
    title: "Start a Career in Permanent Makeup | Cosmetic College",
    description:
      "Learn how to start a career in permanent makeup with Cosmetic College training routes in Orpington, near London.",
  },
  "/courses/aesthetics/microneedling/": {
    title: "Microneedling Training for Beginners | CPD Short Course",
    description:
      "Short CPD microneedling and dermaroller course near London (Orpington), open to beginners: e-learning, then a practical session on models. Groups of 4.",
  },
  "/courses/beauty/dermaplaning/": {
    title: "Dermaplaning Training for Beginners | CPD Short Course",
    description:
      "Short CPD dermaplaning facial course near London (Orpington), open to beginners: e-learning, then a practical session on models we supply. Groups of 4.",
  },
  "/courses/beauty/face-hifu/": {
    title: "HIFU Face and Body Course | One-Day CPD Training",
    description:
      "One-day CPD HIFU face and body course near London (Orpington): e-learning, then a practical day on models we supply. Level 3 recommended. Groups of 4.",
  },
  "/courses/aesthetics/plasma-fibroblast-skin-tightening/": {
    title: "Plasma Fibroblast Training for Beginners | CPD Course",
    description:
      "Short CPD plasma fibroblast course near London (Orpington), no experience needed: e-learning, then a practical session on models we supply. Groups of 4.",
  },
  "/courses/beauty/radiofrequency-ultrasound-cavitation-fat-reduction-and-skin-tightening-training/": {
    title: "Body Cavitation and RF Training | CPD Beginner Course",
    description:
      "Short CPD body course in radiofrequency and ultrasound cavitation near London (Orpington). No experience needed: e-learning, then practical on models.",
  },
  "/courses/beauty/facial-and-skincare/": {
    title: "One-Day Facial Course for Beginners | CPD Training",
    description:
      "One-day CPD facial and skincare course near London (Orpington) for complete beginners: e-learning, then a practical day on models we supply. Groups of 4.",
  },
};

const normalisePath = (pathname: string) => {
  const pathWithoutQuery = pathname.split("?")[0].split("#")[0] || "/";

  if (pathWithoutQuery === "/") {
    return "/";
  }

  return pathWithoutQuery.endsWith("/")
    ? pathWithoutQuery
    : `${pathWithoutQuery}/`;
};

export const getSeoPageOverride = (pathname: string) =>
  SEO_PAGE_OVERRIDES[normalisePath(pathname)] || null;
